export {
  adminBasePath,
  adminPath,
  isAdminHost,
  landingHref,
  receiptHref,
  staffLoginHref,
} from './hosts';

export const config = {
  apiBaseUrl: '/api/v1',
  defaultLocale: 'fa',
  supportedLocales: ['fa', 'en'],
  clinicTimezone: 'Asia/Tehran',
  /** Slot availability is volatile; keep the cache short (CLAUDE.md §7.4). */
  slotStaleTimeMs: 30_000,
  /**
   * How many days of availability the booking page asks for.
   *
   * Deliberately more than any horizon the panel accepts: the booking horizon
   * is a **server** policy (CLAUDE.md §3.2, step 4), so the rail asks wide and
   * renders exactly the days that come back. Keeping a copy of the number here
   * is what made the rail stop at 14 days while the clinic had configured 45.
   * This is the endpoint's own cap, and asking past the horizon costs the
   * server nothing — it clamps before it queries.
   */
  availabilityWindowDays: 120,

  /**
   * The rail's width for the one render before the range arrives. A skeleton
   * length, never a limit — the answer replaces it.
   */
  dayStripFallbackDays: 14,

  /**
   * پیگیری ویزیت — what the composer shows and pre-checks.
   *
   * These mirror `config/records.php` and are **not** the rule: the server
   * decides, against the type detected from the file's own bytes. Keeping a
   * copy here is what lets the UI grey out a sixth file and say what would
   * work, instead of sending an upload that was always going to be refused.
   * If the two ever disagree the server wins, and the patient sees its message.
   */
  records: {
    /**
     * «گفت‌وگو با پزشک» on the patient side — the section on «پیام‌ها» and the
     * «ارسال فایل و پیام» button on an attended نوبت. Hidden for now at the
     * clinic's request until the flow is ready; the backend and the panel's
     * «پیگیری‌ها» are untouched. Flip to `true` to bring both back.
     */
    patientFollowUpsEnabled: false as boolean,
    maxAttachmentMegabytes: 10,
    maxAttachmentsPerMessage: 5,
    /**
     * The `accept` attribute — a filter on the file picker, never a check.
     * A picker can be told to show everything, which is exactly why the
     * detected type is re-validated server-side (CLAUDE.md §3.7).
     */
    acceptedFileTypes: 'image/jpeg,image/png,image/webp,image/heic,application/pdf',
  },
} as const;

export type Locale = (typeof config.supportedLocales)[number];
